import dayjs from 'dayjs';

import 'dayjs/locale/ru';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime)
dayjs.locale('ru')
dayjs.extend(customParseFormat)


import { StringMethods } from '@lexriver/string-methods';
import { Path } from './Path';
import { EnumCurrency } from './website/enums/EnumCurrency';

export module Settings {
    export const version = '2024-10-22'
    export const isProduction: boolean = true

    const useShopDomainForDebug: boolean = false

    // const serverIp = '135.181.40.104' `// hetzner
    const serverIp = '217.25.93.68'
    // const serverIp = '45.153.69.79' // timeweb

    //export const autoReconnect:boolean = false 

    const allUrlPrefix = '/m/'
    export function addPrefixForUrl(url: string) {
        if (url.startsWith(allUrlPrefix)) return url
        return Path.join(allUrlPrefix, url)
    }

    export function addPrefixForAllLocalUrlsInText(text: string) {
        return text
            .replace(/(["'])https\:\/\/uvelina([^/]+)\//g, (x, p1, p2) => `${p1}https://uvelina${p2}/m/`)
            .replace(/(["'])http\:\/\/localhost([^/]+)\//g, (x, p1, p2) => `${p1}http://localhost${p2}/m/`)
            .replace(/(["'])\/([^/]+)/g, (x, p1, p2) => {
                if (p2 == 'm') {
                    return `${p1}/m`
                }
                return `${p1}/m/${p2}`
            })

    }


    export const productTypeAll = 'a' // any 1-char is equal to `all` or `any`
    export const productColorAll = 'a'

    // const rootPathDev = 'https://uvelina.ru/'
    const rootPathDev = `http://${serverIp}:2020/`
    export const getWebsocketServerAddress = (sessionId?: string) => {
        //sessionId = sessionId ?? JSON.parse(localStorage.getItem(localStorageKey_SessionId) ?? '') ?? ''
        sessionId = sessionId ?? ''
        // return isProduction 
        //     ? 'wss://uvelina.ru/api/ws?'+ sessionId
        //     : 'ws://135.181.40.104:2020/api/ws?'+sessionId
        return isProduction
            // ? `wss://${serverIp}/api/ws?${sessionId}`
            ? `wss://uvelina.ru/api/ws?${sessionId}`
            : `ws://${serverIp}:2020/api/ws?${sessionId}`
    }


    export const sidebarWidth: number = 250
    export const sidebarTransitionDuration: string = '.2s'

    export const restServerAddress: string = isProduction ? '/api/rest' : Path.join(rootPathDev, '/api/rest')
    export const websocketRestServerAddress: string = isProduction ? '/api/ws' : Path.join(rootPathDev, '/api/ws')

    export const countOfProductsPerPage: number = 100

    export const localStorageKey_SessionId = 'sessionId'
    export const minUserPasswordLength = 3
    export const minUserPasswordLengthForNewUsers = 8

    const oneMinute = 60 * 1000
    const oneHour = 60 * oneMinute
    export const cacheAgeInMsForCategories: number = oneHour
    export const cacheAgeInMsForProducts: number = oneHour
    export const cacheAgeInMsForProductTypes: number = oneHour
    export const cacheAgeInMsForCountries: number = oneHour
    export const cacheAgeInMsForSettings: number = oneHour
    export const cacheAgeInMsForCoupons: number = oneHour

    export const loadProductsByParts: boolean = true
    export const lazyLoadProductImages: boolean = true
    export const tinyMceDocumentBasePath = isProduction ? 'https://uvelina.ru/' : rootPathDev

    export const topBannerPath: string = isProduction ? '/uploads/slider/' : Path.join(rootPathDev, '/uploads/slider/')
    export const galleryPath: string = isProduction ? '/uploads/gallery/' : Path.join(rootPathDev, '/uploads/gallery/')
    export const tilesPath: string = isProduction ? '/uploads/tiles/' : Path.join(rootPathDev, '/uploads/tiles/')

    export const formatNumberToPrice = (price: number, currency: EnumCurrency) => {

        function getLocaleFromCurrency(currency: EnumCurrency) {
            if (currency === EnumCurrency.RUB) return 'ru'
            if (currency === EnumCurrency.USD) return 'us'
            throw new Error('not implemented')
        }
        // if(!DataTypes.isNumber(price)){
        //     return ''
        // }
        // https://stackoverflow.com/questions/149055/how-to-format-numbers-as-currency-string
        //return (x).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& '); 
        return new Intl.NumberFormat(getLocaleFromCurrency(currency), {
            style: 'currency',
            currency: currency.toUpperCase(),
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(price);
    }


    export const formatNumberToNegativePrice = (price: number, currency: EnumCurrency) => {
        if (price >= 0) return formatNumberToPrice(price, currency)
        return formatNumberToPrice(0 - price, currency)
    }


    //export const minWholesaleOrder:number = 30000
    //export const minOrderForFreeDelivery:number = 3000

    function addSpaces(text: string) {
        let result = text
            .replace(/;/g, '; ')
            .replace(/,/g, ', ')
            .replace(/\(/g, ' (')
            .replace(/:/g, ': ')
            .replace(/"(.+)"/g, ' "$1"')

        // if (replaceMinus) {
        //     result = result.replace(/-/g, ' — ')
        // }
        return result

    }

    // export const formatProductName = (productName:string) => {
    //     return addSpaces(productName, false)
    // }

    export const formatProductName = (productName: string, removeTextInBrackets: boolean = true, addStringUvelina:boolean = false) => {
        let result = addSpaces(productName)
        if (removeTextInBrackets) {
            result = result.replace(/ *\([^)]*\) */g, "")
        }
        if(addStringUvelina){
            result = addStringUvelinaToProductName(result)
        }
    
        return result
    }

    function addStringUvelinaToProductName(productName: string) {
        if (productName.indexOf('Uvelina') >= 0) return productName
        if (productName.indexOf('(') >= 0) {
            productName = productName.replace('(', ' Uvelina (')
        } else {
            productName = productName + ' Uvelina'
        }
        return productName.replace(/\s+/g, ' ')
    }



    export function formatCountOfProducts(count:number){
        if(!count) return ''
        return StringMethods.formatPluralNumber({
            number: count, settings: {
                locale: 'ru', 
                ifZero:(x)=>null,
                ifOne:(x)=>`${x} товар`,
                ifFew:(x)=>`${x} товара`,
                ifMany:(x)=>`${x} товаров`
            }
        })
    }



    export const formatProductDescription = (productDescription: string) => {
        return addSpaces(productDescription)
    }


    export function formatDate(date: string | Date) {
        const x = dayjs(date)
        //console.log('dayjs=', dayjs, 'x=', x)
        return x.format('DD MMMM YYYY HH:mm:ss') + ', ' + x['fromNow']()
    }

    export function formatDateForBirthday(date: string | Date) {
        return dayjs(date).format('DD.MM.YYYY')
    }

    export function formatDateSpecial(date:string|Date, format:string = 'DD.MM.YYYY'){
        return dayjs(date).format(format)
    }



    export const productImagesPath = isProduction
        ? '/product-images/'
        // : Path.join(rootPathDev, '/product-images/')
        : 'https://uvelina.ru/product-images/'
    // export const productImagesPath = isProduction ? '/product-images/' : 'https://uvelina.ru/product-images/'

    export const productAdditionalImagesPath = productImagesPath + 'additional/'

    export const minSecondsToFillUpFormRegister: number = 10
    export const minSecondsToEditUserForm: number = 2

    export function replaceAllLinksToMobile(el: HTMLElement) {
        for (let a of el.querySelectorAll('a')) {
            let href = a.getAttribute('href')
            if (!href) continue
            //console.log('a=', a, 'href=', href)
            if (href.startsWith('/') && !href.startsWith('/m/')) {
                a.href = Settings.addPrefixForUrl(href)
            }
        }
    }

    export function replacePhoneNumberWithLink(phoneNumberText: string) {
        const justNumbers = phoneNumberText.replaceAll(/[^\d]/g, '')
        return `<a href='tel:+${justNumbers}'>${phoneNumberText}</a>`
    }

    export const ecomYandexNewOrderGoalId = 262191058

    export function checkIfDomainIsShop() {
        if (!Settings.isProduction && useShopDomainForDebug) {
            return true
        }
        return window.location.hostname === 'uvelina.shop'
    }

    export function checkIfDomainIsRu() {
        if (!Settings.isProduction && useShopDomainForDebug) {
            return false
        }
        return window.location.hostname === 'uvelina.ru'
    }

    export function getCurrentDomain() {
        return window.location.hostname
    }

    export function checkIfHostIsUvelinaDotShop(host?: string) {
        return host?.toLowerCase() === 'uvelina.shop'
    }

    export const giftCertificateProductId = -3000

    export const errorMessageForBlockedUser = `Ваш аккаунт еще не подтвержден. Пожалуйста ожидайте, либо обратитесь по любым из контактов, указанных на странице "контакты".`

    export const copyrightYear = dayjs().format('YYYY')

    export const productPropertyNameForColor = 'Цвет вставки'

    /**
     * Returns true if the string is looks like valid email
     * @param email 
     * @returns 
     */
    export function validateEmail(email: string) {
        // https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
        const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(String(email).toLowerCase());
    }

    export function parseBirthday(value?:string){
        if(!value || value.length<6) return undefined
        value = value.trim()
        // console.log('parseBirthday', value, dayjs, dayjs(value))
        return ['DD.MM.YYYY', 'D.MM.YYYY', 'D.M.YYYY', 'DD/MM/YYYY', 'D.M.YY', 'DD.M.YY',  'DD.MM.YY', , 'DD/MM/YY'/*, ''*/]
            .map(format => {
                const result = format ? dayjs(value, format) : dayjs(value)
                // console.log('result=', result)
                if(result.isValid()) return result.toDate()
                return undefined
            })
            .filter(date => date && dayjs(date).isAfter(dayjs().subtract(100, 'years')))
            .shift()
    }



}